import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {activateUserAccount} from 'actions/userActions';

import uiHelper from 'helpers/uiHelper';

import AuthContainer from './components/AuthContainer';
import AuthBackgroundImage from './components/AuthBackgroundImage';
import AuthBodyContainer from './components/AuthBodyContainer';
import AuthTitle from './components/AuthTitle';
import AuthLink from './components/AuthLink';

function ActivationPage() {
  const dispatch = useDispatch();
  const location = useLocation();

  let query = new URLSearchParams(location?.search);
  let token = query.get('token');

  useEffect(() => {
    activateAccount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function activateAccount() {
    let response: any = await dispatch(activateUserAccount(token));

    if (response && response.success) {
      uiHelper.showMessage('Your account was successfully activated.');
    }
  }

  return (
    <AuthContainer>
      <AuthBackgroundImage />

      <AuthBodyContainer isSignUp={false}>
        <AuthTitle>Activation Page</AuthTitle>

        <AuthLink url="/login" title="Redirect to login page:" linkText="Login" />
      </AuthBodyContainer>
    </AuthContainer>
  );
}

export default ActivationPage;
